export default "__VITE_ASSET__D$90StvK__";